import { IDeleteItemChecklistServicoUseCase } from "../../../presentation/useCases/delete/delete_item_checklist_servico_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * DeleteItemChecklistServicoUseCase
 */

export class DeleteItemChecklistServicoUseCase implements IDeleteItemChecklistServicoUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async deleteItemChecklistServico(
    idItemChecklistServico: number,
  ): Promise<void> {
    await this.repository.deleteItemChecklistServico(
      idItemChecklistServico,
    );
  }
}
